import { JiraFromUI } from '@app/booking-frontend-libs';
import { useProductContext } from '@forge/react';
import React, { createContext, useEffect, useReducer } from 'react';
import { kv, Logger } from '@app/booking-libs';
const DEFAULT_STATE = {
    userIsLoaded: false,
    isJiraAdmin: false,
    accountId: '',
    timezone: '',
    unlicensed: true
};
function reducer(state, action) {
    return {
        ...state,
        ...action.payload
    };
}
export const JiraUserContext = createContext(DEFAULT_STATE);
const log = new Logger('JiraUserContextProvider');
export function JiraUserContextProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, DEFAULT_STATE);
    const context = useProductContext();
    useEffect(() => {
        async function load() {
            log.debug('Checking if user is Jira admin');
            const isJiraAdmin = await JiraFromUI.checkIfJiraAdmin();
            log.debug(kv('isAdmin', isJiraAdmin));
            dispatch({
                type: 'update',
                payload: {
                    isJiraAdmin
                }
            });
        }
        load();
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: we don't want to react on state.timezone
    useEffect(() => {
        async function load() {
            if (context === null || context === void 0 ? void 0 : context.timezone) {
                dispatch({
                    type: 'update',
                    payload: {
                        accountId: context.accountId,
                        timezone: context.timezone
                    }
                });
            }
            if (!context) {
                log.debug('No context, waiting for it to be available');
                return;
            }
            if (context.accountId) {
                log.debug('Loading user information');
                const user = await JiraFromUI.getUser(context.accountId);
                const payload = {
                    userIsLoaded: true
                };
                if (user) {
                    log.debug(`We have a user ${user.accountId} ${kv('active', user.active)} - ${user.timeZone}`);
                    payload.unlicensed = false;
                    if (user.timeZone && user.timeZone !== state.timezone) {
                        payload.timezone = user.timeZone;
                    }
                }
                dispatch({ type: 'update', payload });
            }
            else {
                log.debug('No accountId, assuming unlicensed');
                dispatch({
                    type: 'update',
                    payload: {
                        userIsLoaded: true,
                        unlicensed: true
                    }
                });
            }
        }
        load();
    }, [context]);
    if (!state.userIsLoaded) {
        return null;
    }
    return React.createElement(JiraUserContext.Provider, { value: state }, children);
}
